import { Flex, Text } from '@chakra-ui/react';
import { Modal, Button, useToast } from '@morressier/alembic';
import { useRemoveReviewer } from '../../../api/commands';

type IProps = {
  onClose: () => void;
  submissionId: string;
  organizationId: string;
  submissionContextId: string;
  reviewId: string;
  reviewsQueryKey: string[];
};

export const RemoveReviewerModal = ({
  onClose,
  submissionId,
  organizationId,
  submissionContextId,
  reviewId,
  reviewsQueryKey
}: IProps) => {
  const removeReviewerMutation = useRemoveReviewer({
    submissionId,
    organizationId,
    submissionContextId,
    reviewId,
    queryKey: reviewsQueryKey
  });
  const toast = useToast();

  const removeReviewer = async () => {
    await removeReviewerMutation.mutate();
    onClose();
    toast({
      variant: 'success',
      title: 'Reviewer Removed',
      description:
        'The reviewer will be notified about this decision via email.',
      isClosable: true
    });
  };

  return (
    <Modal isOpen onClose={onClose} width="448px">
      <Flex padding={8} gap={4} flexDirection="column">
        <Text textStyle="headingGroup">Remove Reviewer?</Text>
        <Text>
          This reviewer will be removed from the current round and will no
          longer participate in further rounds. They will be notified by email.
        </Text>

        <Flex gap={2} justifyContent="flex-end">
          <Button onClick={onClose} variant="secondary">
            Cancel
          </Button>
          <Button type="submit" variant="caution" onClick={removeReviewer}>
            Remove Reviewer
          </Button>
        </Flex>
      </Flex>
    </Modal>
  );
};
